<div class="header-content">
  <!-- Lado Esquerdo: Logo + Ambiente -->
  <div class="header-left">
    <a class="brand" href="#" (click)="navigateHome()">
      <span class="brand-name">RELUZ</span>
      <span class="env-tag" *ngIf="ambiente">{{ambiente}}</span>
    </a>
  </div>

  <!-- Centro: Navegação -->
  <div class="header-center">
    <!-- Alerta de Tarefas (quando houver) -->
    <div class="alert-banner" *ngIf="tarefasPendentes" (click)="navegar('/pages/tarefas/tarefa')">
      <nb-icon icon="alert-circle-outline"></nb-icon>
      <span>TAREFAS PENDENTES</span>
    </div>

    <!-- Menu Principal -->
    <nav class="nav-menu" *ngIf="!tarefasPendentes">
      <a *ngIf="astral" (click)="navegar('/pages/menus/astral')" class="nav-link">
        <nb-icon icon="star-outline"></nb-icon>
        <span>Astral</span>
      </a>
      <a *ngIf="lanc" (click)="navegar('/pages/menus/lancamentos')" class="nav-link">
        <nb-icon icon="edit-outline"></nb-icon>
        <span>Lançamentos</span>
      </a>
      <a *ngIf="vend" (click)="navegar('/pages/menus/vendas')" class="nav-link">
        <nb-icon icon="shopping-cart-outline"></nb-icon>
        <span>Vendas</span>
      </a>
      <a *ngIf="rela" (click)="navegar('/pages/menus/relatorios')" class="nav-link">
        <nb-icon icon="bar-chart-outline"></nb-icon>
        <span>Relatórios</span>
      </a>
      <a *ngIf="gest" (click)="navegar('/pages/menus/gestao')" class="nav-link">
        <nb-icon icon="settings-outline"></nb-icon>
        <span>Gestão</span>
      </a>
      <a *ngIf="camb" (click)="navegar('/pages/menus/cambio')" class="nav-link">
        <nb-icon icon="swap-outline"></nb-icon>
        <span>Câmbio</span>
      </a>
      <a *ngIf="descarga" (click)="navegar('/pages/menus/descarga')" class="nav-link">
        <nb-icon icon="download-outline"></nb-icon>
        <span>Descarga</span>
      </a>
    </nav>
  </div>

  <!-- Lado Direito: Ações + Usuário -->
  <div class="header-right">
    <button class="icon-btn" (click)="goToMsg()" [class.has-badge]="novaMsg" title="Mensagens">
      <nb-icon icon="email-outline"></nb-icon>
      <span class="badge" *ngIf="novaMsg"></span>
    </button>
    
    <button class="icon-btn" (click)="navegar('/pages/tarefas/tarefa')" [class.has-badge]="tarefasPendentes" title="Tarefas">
      <nb-icon icon="clipboard-outline"></nb-icon>
      <span class="badge warning" *ngIf="tarefasPendentes"></span>
    </button>
    
    <div class="user-info">
      <nb-icon icon="person-outline"></nb-icon>
      <span>{{userName}}</span>
    </div>
    
    <button class="icon-btn logout" (click)="logOut()" title="Sair">
      <nb-icon icon="log-out-outline"></nb-icon>
    </button>
  </div>
</div>
